import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { SEARCH_BY } from '../../../common/summary/constants.tsx';
import messages from './messages.tsx';

export const getSelectedTimePeriod = (searchBy: string) => {
	switch (searchBy) {
		case SEARCH_BY.hourly: {
			return messages.atDateTime;
		}

		case SEARCH_BY.weekly: {
			return messages.inWeek;
		}

		case SEARCH_BY.monthly: {
			return messages.inMonth;
		}

		default: {
			return messages.onDate;
		}
	}
};

export const getSelectedTimePeriodMessage = (
	searchBy: string,
	dateTimestamp: string,
	formatMessage: FormatMessage,
): string => {
	const message = getSelectedTimePeriod(searchBy);
	return formatMessage(message, { dateTimestamp });
};
